import React, { useState } from 'react';
import { Plus, Clock, CheckCircle2, AlertCircle, Eye, MousePointer2, Trash2, Copy, Send } from 'lucide-react';
import EmailMailsView from '@ComponentViews/EmailMailsView';
import EmailCampaignsPage from '@Pages/EmailCampaignsPage';
import './EmailsPage.scss';

const CAMPAIGNS = [
    { id: '1', name: 'Product Launch Q3', type: 'Email', status: 'Running', sent: 2540, openRate: 42.5, clickRate: 8.2, date: 'Oct 15, 2023' },
    { id: '2', name: 'Welcome Series Auto', type: 'Email', status: 'Running', sent: 128, openRate: 68.1, clickRate: 24.5, date: 'Ongoing' },
    { id: '3', name: 'Discount Promo Weekend', type: 'Email', status: 'Completed', sent: 5000, openRate: 31.2, clickRate: 4.8, date: 'Oct 08, 2023' },
    { id: '4', name: 'Newsletter Nov', type: 'Email', status: 'Draft', sent: 0, openRate: 0, clickRate: 0, date: 'Nov 01, 2023' },
    { id: '5', name: 'Customer Feedback Survey', type: 'Email', status: 'Paused', sent: 850, openRate: 15.4, clickRate: 2.1, date: 'Sep 28, 2023' },
];

function EmailsPage() {
    const [showForm, setShowForm] = useState(false);
    const [selectedCampaign, setSelectedCampaign] = useState(null);
    const [activeTab, setActiveTab] = useState('mails');

    const getStatusBadge = (status) => {
        switch (status) {
            case 'Running': return { icon: <Clock size={14} />, className: 'status-running' };
            case 'Completed': return { icon: <CheckCircle2 size={14} />, className: 'status-completed' };
            case 'Draft': return { icon: <AlertCircle size={14} />, className: 'status-draft' };
            case 'Paused': return { icon: <AlertCircle size={14} />, className: 'status-paused' };
            default: return { icon: null, className: 'status-default' };
        }
    };

    const toggleAddCampaignsForm = () => {
        setShowForm(!showForm);
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            <div className="email-campaigns-header-row">
                <div>
                    <h1 className="email-campaigns-title">Email</h1>
                    <p className="email-campaigns-desc">Manage your emails and campaigns.</p>
                </div>
                {activeTab === 'campaigns' && (
                    <button className="email-campaigns-btn-new" onClick={toggleAddCampaignsForm}>
                        <Plus size={18} />
                        <span>New Campaign</span>
                    </button>
                )}
            </div>

            <div className="emails-tabs">
                <button 
                    className={`emails-tab ${activeTab === 'mails' ? 'active' : ''}`}
                    onClick={() => setActiveTab('mails')}
                >
                    Mails
                </button>
                <button 
                    className={`emails-tab ${activeTab === 'campaigns' ? 'active' : ''}`}
                    onClick={() => setActiveTab('campaigns')}
                >
                    Campaigns
                </button>
            </div>

            {activeTab === 'mails' ? (
                <EmailMailsView />
            ) : (
                <EmailCampaignsPage />
            )}
        </div>
    );
}

export default EmailsPage;
